import TextButton from "library/Atoms/Button/TextButton";
import DefaultModal from "library/Molecules/Modal/DefaultModal";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const PaymentModal = ({ onClose, children }) => {
  const { t } = useTranslation();

  return (
    <DefaultModal id="payment-modal" title={t("dashboard.modals.paymentModal.title")} onClose={onClose}>
      {children}

      <div className="d-flex col-12 mt-2 px-0 justify-content-center">
        <TextButton
          id="close-payment-modal-btn"
          className="mx-auto"
          label={t("common.buttons.cancelBtn")}
          onClick={onClose}
        />
      </div>
    </DefaultModal>
  );
};

PaymentModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default PaymentModal;
